import { createAction } from '@reduxjs/toolkit';

export const noSearchResultsMessageVisable = createAction('noSearchResultsGuard/messageVisable');
